export const removePTags = (htmlString: string) => {
    const regex = /<\/?p[^>]*>/g;
    return htmlString.replace(regex, '');
}